var $BP_L = 1024;
var $BP_M = 768;
var $BP_S = 480;
var currentWidth = $(window).width();
var activeClass = 'js-active';
function initMenu() {
    var $menuBtn = $('.js-menu-toggle'), $searchBtn = $('.js-search-toggle');
    var $nav = $('.js-nav'), $defaultNav = $('.js-default-nav'), $searchNav = $('.js-search-nav');
    var $header = $('.js-header');
    function toggleMenu() {
        $nav.toggleClass(activeClass);
        $header.toggleClass(activeClass);
    }
    $menuBtn.click(function () {
        $menuBtn.toggleClass(activeClass);
        $defaultNav.addClass(activeClass);
        $searchNav.removeClass(activeClass);
        if ($searchBtn.hasClass(activeClass)) {
            $searchBtn.removeClass(activeClass);
        }
        else {
            toggleMenu();
        }
    });
    $searchBtn.click(function () {
        $searchBtn.toggleClass(activeClass);
        $defaultNav.removeClass(activeClass);
        $searchNav.toggleClass(activeClass);
        if ($menuBtn.hasClass(activeClass)) {
            $menuBtn.removeClass(activeClass);
        }
        else {
            toggleMenu();
        }
    });
}
function initAccordion() {
    $('.js-accordion').aemAccordion({
        openHash: true
    });
}
function initTab() {
    var $tabWrap = $('.tab-wrap');
    $tabWrap.each(function () {
        var $tabTitle = $(this).find('.tab-category li'), $tabTitlesp = $(this).find('.tab-select'), $tabBody = $(this).find('.tab-list__area'), activeClass = 'active';
        $tabTitle.click(function () {
            var index = $tabTitle.index(this);
            $tabTitle.removeClass(activeClass);
            $(this).addClass(activeClass);
            $tabBody.removeClass(activeClass).eq(index).addClass(activeClass);
        });
        $tabTitlesp.change(function () {
            var indexsp = $tabTitlesp.prop('selectedIndex');
            $tabBody.hide();
            $tabBody.removeClass(activeClass).eq(indexsp).addClass(activeClass).fadeIn();
        });
    });
}
function initInview() {
    $('.js-inview').aemInview({
        scrollEnd: true,
    });
}
$(function () {
    $('.aem-post').find('img').wrap('<span class="js-protect"></span>');
    $('.aem-post').find('iframe').each(function () {
        var $iframe = $(this);
        var $parent = $iframe.parent();
        var parentStyle = $parent.attr('style') || '';
        var isWrappedByVideoDiv = parentStyle.includes('position:relative') &&
            parentStyle.includes('padding:') &&
            $parent.children().length === 1 &&
            $parent.children().first().is('iframe');
        var $targetElement = $iframe;
        var targetHtml = $iframe[0].outerHTML;
        if (isWrappedByVideoDiv) {
            $targetElement = $parent;
            targetHtml = $parent[0].outerHTML;
        }
        var isFixedWidth = checkIfFixedWidth(targetHtml);
        var isVertical = checkIfVertical(targetHtml);
        var wrapperClasses = ['movie-wrapper'];
        if (isFixedWidth) {
            wrapperClasses.push('will-responsive-iframe');
        }
        if (isVertical) {
            wrapperClasses.push('is-vertical');
        }
        if (!$targetElement.parent().hasClass('movie-wrapper')) {
            $targetElement.wrap("<div class=\"" + wrapperClasses.join(' ') + "\"></div>");
        }
        var src = $iframe.attr('src') || '';
        if (src.indexOf('youtube') !== -1) {
            var $movieWrapper = $targetElement.parent('.movie-wrapper');
            var width = $iframe.attr('width');
            var height = $iframe.attr('height');
            if (width) {
                width = width.toString().replace(/[^0-9]/g, '');
            }
            if (height) {
                height = height.toString().replace(/[^0-9]/g, '');
            }
            if (width && height) {
                $movieWrapper.css('aspect-ratio', width + '/' + height);
                $movieWrapper.css('width', width);
                $movieWrapper.addClass('movie-wrapper--size');
            }
            else if (width) {
                $movieWrapper.css('aspect-ratio', "16 / 9");
                $movieWrapper.css('width', width);
                $movieWrapper.addClass('movie-wrapper--size');
            }
        }
    });
    $('.aem-post').find('table').wrap('<div class="table-wrapper"></div>');
    $('.js-protect').aemProtectImage({
        blankImg: 'https://cdn.shopify.com/s/files/1/0720/2147/5494/files/blank.gif?v=1773301665'
    });
    $(document).on('contextmenu', 'product-info .images-main img, product-info .images-main__link, product-info .images-sub img, .fancybox-container img', function (e) {
        e.preventDefault();
    });
    $('a[href^="#"]').not('.no-scroll').aemSmoothScroll();
    $('[data-fancybox]').fancybox({
        protect: true,
        loop: true,
        toolbar: true,
        smallBtn: false,
        buttons: [
            "close"
        ],
        baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span class="fancybox-infobar__pagination-current" data-fancybox-index></span><div class="fancybox-infobar__bar"><span class="bar"></span></div><span class="fancybox-infobar__pagination-total" data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
            '</div>' +
            '</div>',
        afterShow: function (instance, current) {
            $('.fancybox-infobar__bar').each(function () {
                $(this).css('--current', current.index + 1);
                $(this).css('--total', instance.group.length);
            });
            $('.fancybox-container img').attr('draggable', false);
        }
    });
    initMenu();
    initAccordion();
    initTab();
    initInview();
});
var $scrollTarget = $('.js-scroll');
var $pagetop = $('.js-pagetop');
var $footer = $('.footer');
$(window).on('scroll', function () {
    if ($scrollTarget.length) {
        $scrollTarget.each(function () {
            var storeLinkTopPosition = $(this).offset().top, storeLinkHeight = $(this).innerHeight(), storeLinkBottomPosition = storeLinkTopPosition + storeLinkHeight;
            var footerTopPosition = $footer.offset().top;
            if (storeLinkBottomPosition >= footerTopPosition) {
                $(this).removeClass(activeClass);
            }
            else {
                if ($(window).scrollTop() > 0) {
                    $(this).addClass(activeClass);
                }
                else {
                    $(this).removeClass(activeClass);
                }
            }
        });
    }
    if ($(window).scrollTop() > 0) {
        $pagetop.addClass(activeClass);
    }
    else {
        $pagetop.removeClass(activeClass);
    }
});
function convertSelectMenu() {
    var $select = $('.js-select-menu');
    $select.each(function () {
        var _this = $(this);
        var selectedValue;
        var selectedHtml;
        _this.append('<dl class="menu-accordion js-accordion">'
            + '<div>'
            + '<dt class="menu-accordion__title js-accordion-title"></dt>'
            + '<dd class="menu-accordion__body js-accordion-body">'
            + '<ul class="search-menu pt-30"></ul>'
            + '</dd>'
            + '</div>'
            + '</dl>');
        if (_this.find('option[selected]').length === 1) {
            selectedValue = _this.find('option[selected]').val();
            selectedHtml = _this.find('option[selected]').html();
        }
        else {
            selectedValue = _this.find('option').first().val();
            selectedHtml = _this.find('option[selected]').first().html();
        }
        _this.find('.js-accordion-title').text(selectedHtml);
        if (_this.find('optgroup').length) {
            var firstValue = $(this).find('option').first().val();
            var firstHTML = $(this).find('option').first().html();
            if (selectedValue === firstValue) {
                _this.find('.js-accordion-body .search-menu:first').append("<li class=\"search-menu__item js-selected\" data-value=\"" + firstValue + "\">\n                        <div class=\"menu-list__inner menu-list__link js-search-menu\"><span>" + firstHTML + "</span></div>\n                    </li>");
            }
            else {
                _this.find('.js-accordion-body .search-menu:first').append("<li class=\"search-menu__item\" data-value=\"" + firstValue + "\">\n                        <div class=\"menu-list__inner menu-list__link js-search-menu\"><span>" + firstHTML + "</span></div>\n                    </li>");
            }
            _this.find('optgroup').each(function () {
                var groupFirstValue = $(this).find('option').first().val();
                var groupFirstHTML = $(this).find('option').first().html();
                var list = '';
                $(this).find('option').each(function (index) {
                    if (index !== 0) {
                        var newValue = $(this).val();
                        var newHTML = $(this).html();
                        var is_none = $(this).prop('disabled');
                        if (is_none) {
                            return;
                        }
                        list = list + '<li class="search-menu__item" data-value="' + newValue + '"><div class="search-menu__inner menu-list__link js-search-menu"><span>' + newHTML + '</span></div></li>';
                    }
                });
                if (selectedValue === groupFirstValue) {
                    _this.find('.js-accordion-body .search-menu:first').append("<li class=\"search-menu__item js-selected\" data-value=\"" + groupFirstValue + "\">\n                            <div class=\"search-menu__inner menu-list__link js-search-menu\"><span>" + groupFirstHTML + "</span></div>\n                            <ul class=\"search-menu\">" + list + "</ul>\n                        </li>");
                }
                else {
                    _this.find('.js-accordion-body .search-menu:first').append("<li class=\"search-menu__item\" data-value=\"" + groupFirstValue + "\">\n                            <div class=\"search-menu__inner menu-list__link js-search-menu\"><span>" + groupFirstHTML + "</span></div>\n                            <ul class=\"search-menu\">" + list + "</ul>\n                        </li>");
                }
            });
        }
        else {
            _this.find('option').each(function () {
                var newValue = $(this).val();
                var newHTML = $(this).html();
                var is_none = $(this).prop('disabled');
                if (is_none) {
                    return;
                }
                if (selectedValue === newValue) {
                    _this.find('.js-accordion-body .search-menu').append('<li class="search-menu__item js-selected" data-value="' + newValue + '"><div class="menu-list__inner menu-list__link js-search-menu"><span>' + newHTML + '</span></div></li>');
                }
                else {
                    _this.find('.js-accordion-body .search-menu').append('<li class="search-menu__item" data-value="' + newValue + '"><div class="menu-list__inner menu-list__link js-search-menu"><span>' + newHTML + '</span></div></li>');
                }
            });
        }
        _this.find('.search-menu__item').each(function () {
            var selected = $(this).parents('.js-accordion-body').prev('.js-accordion-title').text();
            var value = $(this).text();
            if (selected == value) {
                $(this).addClass('js-selected');
            }
        });
        _this.find('.js-search-menu').click(function () {
            var newValue = $(this).parent().data('value');
            $(this).parents('.js-accordion-body').prev('.js-accordion-title').text($(this).text());
            $(this).parents('.js-accordion-body').prev('.js-accordion-title').trigger('click');
            _this.find('.js-search-menu').removeClass('js-selected');
            $(this).addClass('js-selected');
            _this.find('option[selected]').removeAttr('selected');
            _this.find('option[value="' + newValue + '"]').attr('selected', '');
        });
    });
}
function convertProductVariantSelect() {
    var $select = $('.goods-detail__cart .js-select');
    $select.each(function () {
        var _this = $(this);
        var $nativeSelect = _this.find('select.product-variant-id');
        var selectedValue = $nativeSelect.val() || '';
        var selectedText = '';

        if (_this.data('productVariantSelectConverted')) {
            return;
        }
        _this.data('productVariantSelectConverted', true);

        if (selectedValue) {
            selectedText = $nativeSelect.find('option[value="' + selectedValue + '"]').text();
        }
        if (!selectedText) {
            selectedText = $nativeSelect.find('option:first-child').text();
        }

        _this.append('<dl class="select-accordion js-product-variant-accordion">'
            + '<div>'
            + '<dt class="select-accordion__title js-product-variant-accordion-title">'
            + '<span class="select-accordion__text"></span>'
            + '<div class="select-accordion__arrow"></div>'
            + '</dt>'
            + '<dd class="select-accordion__body js-product-variant-accordion-body" style="display: none;">'
            + '<ul class="select"></ul>'
            + '</dd>'
            + '</div>'
            + '</dl>');

        _this.find('.js-product-variant-accordion-title span').text(selectedText);

        $nativeSelect.find('option').each(function () {
            var $option = $(this);
            var newValue = $option.val();
            var newHTML = $option.html();
            var isDisabled = $option.prop('disabled');
            var itemClass = 'select__item';

            if (isDisabled) {
                itemClass += ' js-disabled';
            }
            if (newValue === selectedValue || (!selectedValue && $option.is(':first-child'))) {
                itemClass += ' js-selected';
            }

            _this.find('.js-product-variant-accordion-body .select').append('<li class="' + itemClass + '" data-value="' + newValue + '"><div class="select__inner"><span>' + newHTML + '</span></div></li>');
        });

        _this.find('.js-product-variant-accordion-title').on('click', function (event) {
            event.preventDefault();
            var $title = $(this);
            var $body = $title.next('.js-product-variant-accordion-body');

            $title.toggleClass('js-open');
            $body.stop(true, true).slideToggle(200);
        });

        _this.find('.select__item').on('click', function (event) {
            event.preventDefault();
            var $item = $(this);
            var newValue = $item.data('value');

            if ($item.hasClass('js-disabled')) {
                return;
            }

            if (newValue && newValue !== selectedValue) {
                $item.parents('form').find('#button .button').prop('disabled', false);
            }
            else {
                $item.parents('form').find('#button .button').prop('disabled', true);
            }

            _this.find('.js-product-variant-accordion-title span').text($item.text());
            _this.find('.js-product-variant-accordion-title').removeClass('js-open');
            _this.find('.js-product-variant-accordion-body').stop(true, true).slideUp(200);
            _this.find('.select__item').removeClass('js-selected');
            $item.addClass('js-selected');
            $nativeSelect.val(newValue).trigger('change');
            selectedValue = newValue;
        });
    });
}
function convertSelect() {
    var $select = $('.js-select').not('.goods-detail__cart .js-select');
    $select.each(function () {
        var _this = $(this);
        var selectedValue = '';
        _this.append('<dl class="select-accordion js-accordion">'
            + '<div>'
            + '<dt class="select-accordion__title js-accordion-title">'
            + '<span class="select-accordion__text"></span>'
            + '<div class="select-accordion__arrow"></div>'
            + '</dt>'
            + '<dd class="select-accordion__body js-accordion-body">'
            + '<ul class="select"></ul>'
            + '</dd>'
            + '</div>'
            + '</dl>');
        if (_this.find('option[selected]').length === 1) {
            selectedValue = _this.find('option[selected]').text();
        }
        else {
            selectedValue = _this.find('option:first-child').text();
        }
        _this.find('.js-accordion-title span').text(selectedValue);
        _this.find('option').each(function () {
            var newValue = $(this).val();
            var newHTML = $(this).html();
            var is_none = $(this).prop('disabled');
            if (selectedValue === newValue) {
                _this.find('.js-accordion-body .select').append('<li class="select__item js-selected" data-value="' + newValue + '"><div class="select__inner"><span>' + newHTML + '</span></div></li>');
            }
            else {
                if (is_none) {
                    _this.find('.js-accordion-body .select').append('<li class="select__item js-disabled" data-value="' + newValue + '"><div class="select__inner"><span>' + newHTML + '</span></div></li>');
                }
                else {
                    _this.find('.js-accordion-body .select').append('<li class="select__item" data-value="' + newValue + '"><div class="select__inner"><span>' + newHTML + '</span></div></li>');
                }
            }
        });
        _this.find('.select__item').each(function () {
            var selected = $(this).parent('.js-accordion-body').prev('.js-accordion-title span').text();
            var value = $(this).text();
            if (selected == value) {
                $(this).addClass('js-selected');
            }
        });
        if (_this.hasClass('js-on-change')) {
            var onChange = true;
        }
        _this.find('.select__item').click(function () {
            var newValue = $(this).data('value');
            if (newValue && newValue !== selectedValue) {
                $(this).parents('form').find('#button .button').prop('disabled', false);
            }
            else {
                $(this).parents('form').find('#button .button').prop('disabled', true);
            }
            $(this).parents('.js-accordion-body').prev('.js-accordion-title').find('span').text($(this).text());
            $(this).parents('.js-accordion-body').prev('.js-accordion-title').trigger('click');
            $('.select__item').removeClass('js-selected');
            $(this).addClass('js-selected');
            _this.find('option[selected]').removeAttr('selected');
            _this.find('option[value="' + newValue + '"]').attr('selected', '');
            if (onChange) {
                window.location.href = newValue;
            }
        });
    });
}
convertProductVariantSelect();
convertSelect();
convertSelectMenu();
document.addEventListener('DOMContentLoaded', function () {
    var buttonList = [
        { id: 'a-tag-button', pattern: /^[あいうえお].*/u },
        { id: 'k-tag-button', pattern: /^[かきくけこ].*/u },
        { id: 's-tag-button', pattern: /^[さしすせそ].*/u },
        { id: 't-tag-button', pattern: /^[たちつてと].*/u },
        { id: 'n-tag-button', pattern: /^[なにぬねの].*/u },
        { id: 'h-tag-button', pattern: /^[はひふへほ].*/u },
        { id: 'm-tag-button', pattern: /^[まみむめも].*/u },
        { id: 'y-tag-button', pattern: /^[やゆよ].*/u },
        { id: 'r-tag-button', pattern: /^[らりるれろ].*/u },
        { id: 'w-tag-button', pattern: /^[わをん].*/u },
        { id: 'all-tag-button', pattern: /^.*/ }
    ];
    var tagItems1 = document.querySelectorAll('#tag-list-container-1 .tag-list__item');
    var tagItems2 = document.querySelectorAll('#tag-list-container-2 .tag-list__item');
    var tagItems3 = document.querySelectorAll('#tag-list-container-3 .tag-list__item');
    function filterTags(pattern, tagItems, tagListContainerId) {
        var categories = {};
        var tagListContainer = document.getElementById(tagListContainerId);
        if (tagListContainer) {
            tagListContainer.style.display = 'block';
            tagItems.forEach(function (item) {
                var _a;
                var yomi = item.getAttribute('data-yomi');
                var menuAccordionS = item.closest('.menu-accordion-s');
                if (menuAccordionS) {
                    var categoryId = (_a = menuAccordionS.querySelector('.menu-accordion-s__title')) === null || _a === void 0 ? void 0 : _a.id.split('-')[1];
                    if (yomi && yomi.match(pattern)) {
                        item.style.display = 'list-item';
                        categories[categoryId] = true;
                    }
                    else {
                        item.style.display = 'none';
                    }
                }
            });
            document.querySelectorAll("#" + tagListContainerId + " .menu-accordion-s__title").forEach(function (title) {
                var categoryId = title.id.split('-')[1];
                if (categories[categoryId]) {
                    title.style.display = 'block';
                }
                else {
                    title.style.display = 'none';
                }
            });
        }
    }
    function filterTagsForContainer3(pattern, tagItems, tagListContainerId) {
        var categories = {};
        var tagListContainer = document.getElementById(tagListContainerId);
        if (tagListContainer) {
            tagListContainer.style.display = 'block';
            tagItems.forEach(function (item) {
                var yomi = item.getAttribute('data-yomi');
                var menuAccordionS = item.closest('.menu-accordion-s');
                var title = menuAccordionS === null || menuAccordionS === void 0 ? void 0 : menuAccordionS.querySelector('.menu-accordion-s__title');
                var tagContainer = title === null || title === void 0 ? void 0 : title.closest('.tag-container');
                if (menuAccordionS && title && tagContainer) {
                    var categoryId = title.id.split('-')[1];
                    if (yomi && yomi.match(pattern)) {
                        item.style.display = 'list-item';
                        categories[categoryId] = true;
                    }
                    else {
                        item.style.display = 'none';
                    }
                    if (categories[categoryId]) {
                        title.style.display = 'block';
                        if (window.innerWidth <= 768) {
                            tagContainer.style.marginBottom = '56px';
                        }
                        else {
                            tagContainer.style.marginBottom = '77px';
                        }
                    }
                    else {
                        title.style.display = 'none';
                        tagContainer.style.marginBottom = '0';
                    }
                }
            });
        }
    }
    buttonList.forEach(function (button) {
        var _a, _b, _c;
        (_a = document.getElementById(button.id + '-1')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            filterTags(button.pattern, tagItems1, 'tag-list-container-1');
        });
        (_b = document.getElementById(button.id + '-2')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () {
            filterTags(button.pattern, tagItems2, 'tag-list-container-2');
        });
        (_c = document.getElementById(button.id + '-3')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
            filterTagsForContainer3(button.pattern, tagItems3, 'tag-list-container-3');
        });
    });
});
function checkIfFixedWidth(targetHtml) {
    var hasPaddingRatio = !!targetHtml.match(/padding(?:-top)?:\s*[0-9]+(?:\.[0-9]+)?%/);
    if (hasPaddingRatio) {
        return false;
    }
    var hasWidthAndHeight = targetHtml.match(/width="(.*?)"/) && targetHtml.match(/height="(.*?)"/);
    var noPadding = !targetHtml.match(/padding(?:-top)?/);
    return !!hasWidthAndHeight || noPadding;
}
function checkIfVertical(targetHtml) {
    var paddingMatch = targetHtml.match(/padding(?:-top)?:\s*([0-9]+(?:\.[0-9]+)?)%/);
    if (paddingMatch && parseFloat(paddingMatch[1]) >= 100) {
        return true;
    }
    return false;
}

//# sourceMappingURL=main.js.map
